import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-import fa-5x pb-4 pt-2" })
], -1)
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "management-name"
}, "Name", -1)
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "management-description"
}, "Description", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_p = _resolveComponent("n-p")!
  const _component_n_upload_dragger = _resolveComponent("n-upload-dragger")!
  const _component_n_upload = _resolveComponent("n-upload")!
  const _component_n_input = _resolveComponent("n-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_n_upload, {
              "default-upload": false,
              max: 1,
              onChange: _ctx.handleChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_upload_dragger, null, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createVNode(_component_n_text, { style: {"font-size":"16px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Click or drag a file to this area to upload ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_n_p, {
                      depth: "3",
                      style: {"margin":"8px 0 0 0"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Accepted File: " + _toDisplayString(_ctx.accept), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_n_input, {
              type: "text",
              id: "management-name",
              value: _ctx.modelValue.original_name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.original_name) = $event)),
              disabled: "",
              size: "large",
              placeholder: "Name"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_n_input, {
              type: "text",
              id: "management-description",
              value: _ctx.modelValue.description,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.description) = $event)),
              disabled: _ctx.viewOnly,
              size: "large",
              placeholder: "Description"
            }, null, 8, ["value", "disabled"])
          ])
        ])
      ])
    ])
  ]))
}